export const REGISTER = "REGISTER";
export const LOGIN = "LOGIN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const LOGOUT = "LOGOUT";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const ALL_QUEST = "ALL_QUEST";
export const CREATE_QUEST = "CREATE_QUEST";
export const UPDATE_QUEST = "UPDATE_QUEST";
export const DELETE_QUEST = "DELETE_QUEST";
export const FETCH_QUIZ = "FETCH_QUIZ";
export const SEND_RESULT = "SEND_RESULT";
export const RESET = "RESET";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_USERS = "FETCH_USERS";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const START_LOADING_QUEST = "START_LOADING_QUEST";
export const END_LOADING_QUEST = "END_LOADING_QUEST";
export const ME = "ME";
export const AUTH_START_LOADING = "AUTH_START_LOADING";
export const AUTH_END_LOADING = "AUTH_END_LOADING";
export const PASSWORD = "PASSWORD";
export const FETCH_SCHEDULE = "FETCH_SCHEDULE";
export const POST_SCHEDULE = "POST_SCHEDULE";
export const DELETE_SCHEDULE = "DELETE_SCHEDULE";
export const EDIT_SCHEDULE = "EDIT_SCHEDULE";
export const GROUP_SCHEDULE = "GROUP_SCHEDULE";
